import { BillingCycleTypes } from "../../domain/invoice";
import { SortItem } from "./member.dashboard.license.response";

export enum HoldStatuses {
    None = 0,
    Active = 1,
    LicenseResumed = 2,
    HoldFinished = 3,
    HoldFinishedDeclined = 4,
    HoldFinishedCancelled = 5 
}


export class HoldStatusesArray extends Array<HoldStatuses> {
    public LastSort: SortItem;

    constructor(...items: HoldStatuses[]) {
        super(...items);
        Object.setPrototypeOf(this, HoldStatusesArray.prototype);
    }

}

export class HoldStatisticsItem {

	ID: number;
	
	BillingCycle: string;
	BillingCycleType: BillingCycleTypes;
	
    HoldStatus: HoldStatuses;
	
	DateTimeCreated: Date;
	HoldStartDate: Date;
    HoldEndDate: Date;
	LicenseResumeDate: Date;
    HoldFinishedDate: Date;

	TotalHoldCost: number;
    HoldGroup_ID: number;
    HoldGroupItem_ID: number;
    License_ID: number;
    HoldMonths: number;
    
    MemberID: number;
	DesignerID: number;
	
    CompanyName: string;
    MemberName: string;
    DesignerName: string;
    LicenseKey: string;
    ProductName: string;
	
	ProductID: number;
    
    HoldGroupName: string;
    HoldGroupItemDescription: string;
	
	HoldStarted: boolean;
    FirstMonthOfHold: boolean;

    public static FixDates(item: HoldStatisticsItem) {
        item.DateTimeCreated = new Date(item.DateTimeCreated);
        item.HoldStartDate = new Date(item.HoldStartDate);
        item.HoldEndDate = new Date(item.HoldEndDate);
        item.LicenseResumeDate = new Date(item.LicenseResumeDate);
        item.HoldFinishedDate = new Date(item.HoldFinishedDate);
    }

}

export class HoldStatisticsItemArray extends Array<HoldStatisticsItem> {
    public LastSort: SortItem;

    constructor(...items: HoldStatisticsItem[]) {
        super(...items);
        Object.setPrototypeOf(this, HoldStatisticsItemArray.prototype);
    }

    public static FixDates(items: HoldStatisticsItemArray) {
        items.forEach(x => HoldStatisticsItem.FixDates(x));
    }

}
